import { deepComputedFrom } from 'aurelia-deep-computed';
import { autoinject, computedFrom } from 'aurelia-framework';
import { CountryVisitsPanelCustomElement } from 'components/country-visits-panel';
import { WidgetController } from 'controls/as-widget-container';
import { CountryVisit } from 'model/forms/travel-request';
import { KeywordsService } from 'services/keywords-service';
import { aprovalRequired, SafetyService } from 'services/safety-service';
import { WidgetBase } from 'support/base_classes/widget-base';

@autoinject
export class CountryVisitWidget extends WidgetBase<CountryVisit, WidgetController> {
  constructor(private keywords: KeywordsService, private safety: SafetyService, private panel: CountryVisitsPanelCustomElement) {
    super();
  }

  @computedFrom('model.country.formFlag')
  get widgetIcon() {
    return this.model.country?.formFlag ?? 'fas fa-globe-africa';
  }

  @computedFrom('controller.index')
  get countryNumber() {
    return this.controller.index + 1;
  }

  @deepComputedFrom('keywords.countries', 'panel.items', 'model.country')
  get countries() {
    return this.keywords.ensureItem(this.keywords.countries.filter(c => !this.panel.items.some(i => i.country === c)), this.model.country);
  }

  @computedFrom('safety.countrySettings', 'model.country')
  get countrySettings() {
    return this.model.country == null ? null : this.safety.countrySettings.get(this.model.country.id) ?? null;
  }

  @computedFrom('model.transit', 'countrySettings')
  get approvalRequired() {
    return aprovalRequired(this.countrySettings?.approvalRequirementValue, this.model.transit);
  }

  @computedFrom('model.country', 'countrySettings', 'approvalRequired')
  get message() {
    if (this.countrySettings == null) return null;
    const message = this.countrySettings.conditionMessage != null ? this.countrySettings.conditionMessage :
      this.approvalRequired ? `Security approval is required for ${this.model.country.name}.` : `Security approval is not required.`;
    return `${message} (${this.countrySettings.approvalLevel.name})`;
  }
}
